import imageBrowserHeader from "../imageBrowser/ImageBrowserHeader";
import imageBrowserBody from "../imageBrowser/ImageBrowserBody";
import spectralisBrowserBody from "../imageBrowser/oct/SpectralisBrowserBody";
import cirrusBrowserBody from "../imageBrowser/oct/CirrusBrowserBody";
import spectralisComparisonBody from "../imageBrowser/oct/SpectralisComparisonBody";
import cirrusComparisonBody from "../imageBrowser/oct/CirrusComparisonBody";
import rasterBrowserBody from "../imageBrowser/oct/RasterBrowserBody";
import hvfBrowserBody from "../imageBrowser/hvf/HVFBrowserBody";
import hvfMultiviewBody from "../imageBrowser/hvf/HVFMultiviewBody";
import { mapGetters } from "vuex";
export default {
  components: {
    imageBrowserHeader,
    imageBrowserBody,
    spectralisBrowserBody,
    cirrusBrowserBody,
    spectralisComparisonBody,
    cirrusComparisonBody,
    rasterBrowserBody,
    hvfBrowserBody,
    hvfMultiviewBody
  },
  computed: {
    ...mapGetters(["imageBrowserContext"]),
    bodyComponent() {
      return this.imageBrowserContext && this.imageBrowserContext.componentName || "imageBrowserBody";
    },
    browserName(){
      return this.imageBrowserContext && this.imageBrowserContext.browserName;
    }
  }
}